<script setup>
import { ref, onMounted } from "vue";
import { Modal } from "bootstrap";
import ConfirmacionModal from "./ConfirmacionModal.vue";
import WarningModal from "./WarningModal.vue";
import { formatNumber } from "@/utils/helpers";

const props = defineProps({
  LoteStore: Object,
  preguntarAlert: Object,
});

const confirmacionAlert = ref(null);
const warningAlert = ref(null);
const warningMessage = ref("");
const prorrogaActivada = ref(false)

onMounted(() => {
  confirmacionAlert.value = new Modal(
    document.getElementById("ofertaEnviadaModal"),
    { backdrop: "static", keyboard: false }
  );
  warningAlert.value = new Modal(
    document.getElementById("ofertaWarningModal"),
    { backdrop: "static", keyboard: false }
  );
});

async function confirmarOferta() {
  try {
    const fechaAnterior = new Date(props.LoteStore.puja.fecha_hora_cierre);
    await props.LoteStore.ofertar();
    const fechaNueva = new Date(props.LoteStore.puja.fecha_hora_cierre);

    props.preguntarAlert.hide();

    if (fechaNueva > fechaAnterior) {
      localStorage.setItem(`prorroga_${props.LoteStore.lote.id}`, "true");
      prorrogaActivada.value = true;
    } 
    confirmacion();
  } catch (error) {
    warningMessage.value = error.response.data;
    props.preguntarAlert.hide();
    warningAlert.value.show();
  }
}


function confirmacion() {
  confirmacionAlert.value.show();
}

function cerrarModal() {
  props.LoteStore.inicializarPanel();
  props.preguntarAlert.hide();
}
</script>

<template>
  <!-- Modal de Bootstrap -->
  <div class="modal fade" id="preguntarModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center p-5 position-relative">
        <button type="button"
          class="position-absolute top-0 end-0 m-2 me-2 bg-soft-grey border-0 rounded-circle d-flex align-items-center justify-content-center"
          style="width: 40px; height: 40px;" @click="cerrarModal" aria-label="Close">
          <span class="fs-global-iconos mb-1">&times;</span>
        </button>

        <div class="d-flex justify-content-center align-items-center mb-1 text-center">
          <div class="icono-alerta bg-soft-green d-flex align-items-center justify-content-center me-2"
              style="border-radius: 50%;">
            <i class="fas fa-exclamation text-soft-green fs-global-iconos"></i>
          </div>
          <h6 class="text-soft-green mb-0 fs-global-titulos">¡Estás por ofertar!</h6>
        </div>

        <div class="modal-body text-center">
          <h2 class="text-soft-green"><span class="me-1">$</span>{{ formatNumber(props.LoteStore.panelOferta.nueva_oferta) }}
          </h2>
        </div>
        <div class="d-flex flex-column">
          <button class="btn btn-soft-green w-100" @click="confirmarOferta">Confirmar oferta</button>
          <button class="mt-2 btn btn-link text-soft-green text-decoration-underline" @click="cerrarModal()">Cancelar oferta</button>
        </div>
      </div>
    </div>
  </div>

  <ConfirmacionModal :LoteStore="LoteStore" :confirmacionAlert="confirmacionAlert" :prorrogaActivada="prorrogaActivada"/>
  <WarningModal :LoteStore="LoteStore" :confirmacionAlert="warningAlert" :mensaje="warningMessage" />
</template>

